module.exports = __webpack_public_path__ + "static/img/001-01.f46e6c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SVG/001-01.svg
// module id = M45e
// module chunks = 1